<h2 mat-dialog-title>Resource wizard</h2>
<div class="loader">
  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</div>
@if (formGroup) {
  <form [formGroup]="formGroup" style="padding-top: 16px">
    <div mat-dialog-content>
      <div formGroupName="resourceKeyGroup">
        <mat-form-field appearance="outline">
          <mat-label>Resource key</mat-label>
          <input formControlName="resourceKey"
                 id="resourceKey"
                 matInput
                 type="text" />
        </mat-form-field>
      </div>
      @for (lang of data.languages; track lang) {
        <div
          [formGroupName]="lang.id"
          class="side__form-group">
          <input formControlName="id" id="id" type="hidden" />
          <mat-form-field appearance="outline">
            <mat-label>{{ getLangCode(lang.id) }}</mat-label>
            <input formControlName="text"
                   id="text"
                   matInput
                   type="text" />
          </mat-form-field>
        </div>
      }
    </div>
    <mat-dialog-actions>
      <button (click)="dialogRef.close()"
              mat-flat-button
              type="button">
        Close
      </button>
      <button (click)="closeAndDisable()"
              mat-flat-button
              color="accent"
              matTooltip="Close and disable interactive wizzard"
              type="button">
        Close and off
      </button>
      <button (click)="onSubmit()"
              mat-flat-button
              color="primary"
              [disabled]="formGroup.invalid"
              matTooltip="Close and disable interactive wizzard"
              type="submit">
        Submit
      </button>
    </mat-dialog-actions>
  </form>
}

